import authService from "./authService";

const setAnswerLocalStorage = (userGuid, answer) => {
    localStorage.setItem(userGuid, JSON.stringify(answer));
}

const getAnswerLocalStorage = (userGuid) => {
    const local = localStorage.getItem(userGuid);
    if (local) {
        try {
            return JSON.parse(local);
        } catch (error) {
            return null;
        }
    }
}

const setAnswer = async (answer) => {
    try {
        if (await authService.isValid()) {
            const userInfo = await authService.getUserInfo();
            if (userInfo && userInfo.accessToken && userInfo.accessToken.payload && userInfo.accessToken.payload.username) {
                answer.userId = userInfo.accessToken.payload.username;
                setAnswerLocalStorage(answer.userId, answer);
            }
        }
    } catch (error) {

    }
}

const deleteAnswer = async () => {
    await setAnswer({});
}

const getAnswer = async () => {
    try {
        if (await authService.isValid()) {
            const userInfo = await authService.getUserInfo();
            if (userInfo && userInfo.accessToken && userInfo.accessToken.payload && userInfo.accessToken.payload.username) {
                const data = getAnswerLocalStorage(userInfo.accessToken.payload.username);
                if (data && data.date && isDifference6Time(data.date)) {
                    return data;
                }
            }
        }
    } catch (error) {

    }
}

const isDifference6Time = (start) => {
    var date1 = new Date(start);
    var date2 = new Date();

    var Difference_In_Time = date2.getTime() - date1.getTime();
    var Difference_In_Clock = Difference_In_Time / (1000 * 3600);

    return Math.ceil(Difference_In_Clock) <= 6;
}

const getAnswerNormal = () => {
    try {
        if (authService.isValidNormal()) {
            const username = authService.getUserInfoNormal();
            if (username) {
                const data = getAnswerLocalStorage(username);
                if (data && data.date && isDifference6Time(data.date)) {
                    return data;
                }
            }
        }
    } catch (error) {

    }
}

export default { setAnswer, getAnswer, deleteAnswer, getAnswerNormal };
